__turbopack_context__.v({
  "tooltip": "styles-module-scss-module__SQM84G__tooltip",
  "tooltip-container": "styles-module-scss-module__SQM84G__tooltip-container",
});
